import React, { useState } from 'react';
import { Grid } from '@mui/material';
import {
    ImportContactsOutlined,
    LibraryBooksOutlined,
} from '@mui/icons-material';

import { Divider } from '@/operator/components/general/divider/Styles';
import SmallHeaderWithIconAndDescription from '@/operator/components/general/header/SmallHeaderWithIconAndDescription';
import { Invitation } from '@/operator/graphql/types/Invitation';

import UploadCsvFile from './UploadCsvFile';
import SendInvitationList from './SendInvitationList';

const SendCSVInvites: React.FC = () => {
    const [invitationList, setInvitationList] = useState<Invitation[]>([]);
    const [csvFile, setCsvFile] = useState<File>();

    const getUserInstructions = () => {
        if (csvFile) {
            return (
                <SmallHeaderWithIconAndDescription
                    Icon={ImportContactsOutlined}
                    title="Awesome CSV"
                    description="Just need to hit that upload button now, and we’ll import

      your email addresses."
                    customStyle={{
                        marginTop: '31px',
                    }}
                />
            );
        }
        return (
            <SmallHeaderWithIconAndDescription
                Icon={LibraryBooksOutlined}
                title="There’s no one here"
                description="Upload a CSV (Comma Separated Values) of the email

        addresses you want to add."
                customStyle={{
                    marginTop: '31px',
                }}
            />
        );
    };

    return (
        <Grid container gap="50px">
            <Grid item xs={5}>
                <UploadCsvFile
                    setInvitationList={setInvitationList}
                    csvFile={csvFile}
                    setCsvFile={setCsvFile}
                />
            </Grid>
            <Divider />
            <Grid item xs={6}>
                {invitationList.length > 0 ? (
                    <SendInvitationList
                        emailsAmount={invitationList.length}
                        invitationList={invitationList}
                        setInvitationList={setInvitationList}
                    />
                ) : (
                    getUserInstructions()
                )}
            </Grid>
        </Grid>
    );
};

export default SendCSVInvites;
